// ==============================================================================
// Imports - Packages & Utils
// ==============================================================================

import React from "react";
import Router from "./Router";
import {connect} from "react-redux";

// ==============================================================================
// Imports - Application wide styles
// ==============================================================================

import "./styles/styles.global.scss";
import Portal from "./common/components/Portal";
import SalesReportPage from "./common/components/Reports/SalesReport";

// ==============================================================================
// Class - App
// ==============================================================================

export class App extends React.Component {

    render() {
        const {displayVeritasSourcesPDFReport} = this.props;

        return (
            <div className="marvel-container">
                <Router />
                <div className="report-portal-container">
                    {displayVeritasSourcesPDFReport
                        ? (
                            <Portal>
                                <SalesReportPage />
                            </Portal>)
                        : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    displayVeritasSourcesPDFReport: state.report.pdfReports.displayVeritasSourcesPDFReport,
});

export default connect(
    mapStateToProps,
)(App)
